
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { useAuth } from "@/context/auth";

export const useProtectedRouteRedirect = () => {
  const location = useLocation();
  const { toast } = useToast();
  const { user, loading } = useAuth();
  
  // Check if the user was redirected here from a protected route
  useEffect(() => {
    const from = location.state?.from?.pathname;
    if (from && from !== "/" && !loading && !user) {
      toast({
        title: "Authentication required",
        description: "Please login to access this page",
      });
    }
  }, [location.state, loading, user, toast]);
};
